import { RefundRequestItemJSON } from "./refund-request";

export class RefundRequestItemValidator {
  constructor(readonly item: RefundRequestItemJSON) {}

  validate(): {
    amount?: string;
  } {
    const error: {
      amount?: string;
    } = {};
    if (this.item.refundAmount === 0) {
      return error;
    }
    if (!this.item.refundAmount || this.item.refundAmount < 0) {
      error["amount"] = "数字を半角で入力してください。";
    }
    if (this.item.refundAmount > this.item.refundableAmount) {
      error["amount"] = "返金上限以下の金額を入力してください。";
    }
    return error;
  }
}
